import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';
import { CheckboxInput } from 'component/Checkbox';
import { DIRECT_EVIDENCE_LEGACY_OPTIONS, DIRECT_EVIDENCE_V2_OPTIONS } from 'consts/Evidences';

export const DirectEvidence = (props) => {
  const evidences = props.formData.info.evidences.direct_evidences;
  const evidenceOptions = props.formData?.info?._schema_version === 2
    ? DIRECT_EVIDENCE_V2_OPTIONS
    : DIRECT_EVIDENCE_LEGACY_OPTIONS;

  const handleEvidenceInput = (value, isChecked) => {
    const evidenceTypes = [...(evidences.evidence_types ?? [])];

    if (isChecked) {
      if (!evidenceTypes.includes(value)) {
        evidenceTypes.push(value);
      }
    } else {
      const index = evidenceTypes.indexOf(value);
      if (index !== -1) {
        evidenceTypes.splice(index, 1);
      }
    }

    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        evidences: {
          ...prevFormData.info.evidences,
          direct_evidences: {
            ...prevFormData.info.evidences.direct_evidences,
            evidence_types: evidenceTypes,
          },
        },
      },
    }));
  };

  return (
    <AccordionBodyItem
      accordionSubId="4.1"
      titleUA="Прямі докази"
      titleEN="Direct evidence"
      children={(
        <div className="flex-group flex-wrap">
          {evidenceOptions.map((option) => (
            <CheckboxInput
              key={option.value}
              id={`direct-evidence-${option.value}`}
              name={option.value}
              value={option.value}
              label={option.label}
              checked={evidences.evidence_types?.includes(option.value)}
              handleInput={handleEvidenceInput}
              disable="false"
            />
          ))}
        </div>
      )}
    />
  );
};
